import { yupResolver } from '@hookform/resolvers/yup';
import AddIcon from '@mui/icons-material/Add';
import { Button, Stack } from '@mui/material';
import PageHeaderText from 'layout/pages/PageHeaderText';
import PageHeaderWrapper from 'layout/pages/PageHeaderWrapper';
import { isNil } from 'lodash';
import { FormContainer, TextFieldElement, useForm } from 'react-hook-form-mui';
import { object, string } from 'yup';
import type { FC } from 'react';
import type { SubmitHandler } from 'react-hook-form-mui';

interface OrdersFilterData {
  search: string;
}

const schema = object<OrdersFilterData>({
  search: string().max(300),
}).required();

const OrdersPageHeader: FC<OrdersPageHeaderProps> = ({
  onSearchChanged,
  searchTextInit,
  onCreateClick,
  hideCreateButton,
  title,
}) => {
  const formContext = useForm<OrdersFilterData>({
    mode: 'onChange',
    defaultValues: {
      search: searchTextInit ?? '',
    },
    resolver: yupResolver(schema),
  });

  const filter: SubmitHandler<OrdersFilterData> = (data) => {
    !isNil(onSearchChanged) && onSearchChanged(data.search);
  };

  return (
    <PageHeaderWrapper>
      <PageHeaderText align='center' text={title} />

      <Stack direction={'row'} spacing={1} sx={{ alignItems: 'center' }}>
        <FormContainer
          FormProps={{ style: { flexGrow: 1 } }}
          formContext={formContext}
          onSuccess={filter}>
          <TextFieldElement
            size='small'
            fullWidth
            name='search'
            placeholder='Поиск'
            type='search'
          />
        </FormContainer>

        {!(hideCreateButton ?? false) && (
          <Button startIcon={<AddIcon />} onClick={onCreateClick} variant='contained'>
            Создать
          </Button>
        )}
      </Stack>
    </PageHeaderWrapper>
  );
};

export interface OrdersPageHeaderProps {
  hideCreateButton?: boolean;
  searchTextInit?: string;
  onSearchChanged?: (text: string) => void;
  onCreateClick?: VoidFunction;
  title: string;
}

export default OrdersPageHeader;
